// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\otp-verification.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\otp-verification.tsx");
  import.meta.hot.lastModified = "1759761980446.823";
}
// REMIX HMR END

import OtpVerification from '~/components/auth/OtpVerification';
import { PublicRoute } from "~/components/RouteProtection";
export const meta = () => {
  return [{
    title: 'OTP Verification - Nomadic Studios'
  }, {
    name: 'description',
    content: 'Verify your phone number to complete registration'
  }];
};
export default function OtpVerificationPage() {
  return <PublicRoute>
      <OtpVerification />
    </PublicRoute>;
}
_c = OtpVerificationPage;
var _c;
$RefreshReg$(_c, "OtpVerificationPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;